import Vue from 'vue'
import Router from 'vue-router'


// // import GatewayAdmin from '../pages/GatewayAdmin.vue'
// // import GatewayUser from '../pages/GatewayUser.vue'
// import AdminLists from '../pages/AdminLists.vue'
// import NodeUser from '../pages/NodeUser.vue'

import Login from '../pages/Login/index.vue'
import Error from '../pages/404/index.vue'
import Index from '../pages/index/index.vue'
import Home from '../pages/Home/index.vue'

// 系统管理模块
import SystemManage from '../pages/SystemManage/index'
import SystemManageLists from '../pages/SystemManage/lists'
import SystemManageOrganizational from '../pages/SystemManage/organizational'
import SystemManageRole from '../pages/SystemManage/role'
import SystemManageRoleAdd from '../pages/SystemManage/roleAdd'
import SystemManageMenu from '../pages/SystemManage/menu'
import SystemManageSql from '../pages/SystemManage/sql'
import SystemManageTiming from '../pages/SystemManage/timing'
import SystemManageParameter  from'../pages/SystemManage/parameter'
import SystemManageFileUpload from '../pages/SystemManage/fileUpload'
import SystemManageSystemLog from '../pages/SystemManage/systemLog'
import SystemManageDict from '../pages/SystemManage/dict'
import SystemManageTimingLog from '../pages/SystemManage/timingLog'

// 采购业务模块
import Procurement from '../pages/Procurement/index.vue'
import ProcurementLists from '../pages/Procurement/lists.vue'

// import GateWayAdminInfo from '../pages/GateWayAdminInfo.vue'
// import GatewayUserInfo from '../pages/GatewayUserInfo.vue'
// import NodeInfo from '../pages/NodeInfo.vue'

// import Register from '../pages/Register.vue'


// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢, 所以只有开发环境使用懒加载
// const _import = require('./import-' + process.env.NODE_ENV)


Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      desc: '登录'
    },
    {
      path: '/',
      meta: {
        title: 'Index',
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      },
      name: 'Index',
      redirect: { name: 'firstpage' } ,
      component: require('../pages/index.vue'),
      children: [
          {
            path: '/firstpage',
            name: 'firstpage',
            meta: { requiresAuth: true },
            component: require('../pages/firstpage.vue'),
            desc: '首页',
          },
          // {
          //   path: '/home/index',
          //   name: 'Home',
          //   meta: { requiresAuth: true },
          //   component: Home,
          //   desc: '首页',
          // },
          {
            path: '/SystemManage/addmeau',
            meta: { requiresAuth: true },
            component: SystemManage,
            desc: '系统管理',
            meta: { isTab: true  },
          },
          {
            path: '/SystemManage/organizational',
            meta: { requiresAuth: true },
            component: SystemManageOrganizational,
            desc: '组织架构管理',
            meta: { isTab: true  },
          },
          {
            path: '/SystemManage/lists',
            meta: { requiresAuth: true },
            component: SystemManageLists,
            desc: '管理员管理',
            meta: { isTab: true  },
          },
          {
            path: '/SystemManage/role',
            meta: { requiresAuth: true },
            component: SystemManageRole,
            name:'Role',
            desc: '角色管理',
            meta: { isTab: true  },

          },
          {
            path: '/SystemManage/timingLog',
            meta: { requiresAuth: true },
            component: SystemManageTimingLog,
            name: 'timingLog',
            desc: '定时任务日志列表',
            meta: { isTab: true  },
          },
          {
            path: '/SystemManage/roleAdd',
            meta: { requiresAuth: true },
            component: SystemManageRoleAdd,
            name: 'roleAdd',
            desc: '角色管理-新增',
            meta: { isTab: true  },
          },
          {
            path: '/SystemManage/menu',
            meta: { requiresAuth: true },
            component: SystemManageMenu,
            desc: '菜单管理',
            meta: { isTab: true  },
          },
          {
            path: '/SystemManage/sql',
            meta: { requiresAuth: true },
            component: SystemManageSql,
            desc: 'sql监控',
            meta: { isTab: true  },
          },
          {
            path: '/SystemManage/schedule',
            meta: { requiresAuth: true },
            component: SystemManageTiming,
            desc: '定时任务',
            meta: { isTab: true  },
          },
          {
            path: '/SystemManage/parameter',
            meta: { requiresAuth: true },
            component: SystemManageParameter,
            desc: '参数管理',
            meta: { isTab: true  },
          },
          {
            path: '/SystemManage/dict',
            meta: { requiresAuth: true },
            component: SystemManageDict,
            desc: '字典管理',
            meta: { isTab: true  },
          },
          {
            path: '/SystemManage/upload',
            meta: { requiresAuth: true },
            component: SystemManageFileUpload,
            desc: '文件上传',
            meta: { isTab: true  },
          },
          {
            path: '/SystemManage/systemLog',
            meta: { requiresAuth: true },
            component: SystemManageSystemLog,
            desc: '系统日志',
            meta: { isTab: true  },
          },
          {
            path: '/Procurement/index',
            meta: { requiresAuth: true },
            component: Procurement,
            desc: '采购业务',
            meta: { isTab: true  },
          },
          {
            path: '/Procurement/addPurchaseOrder',
            meta: { requiresAuth: true },
            component: ProcurementLists,
            desc: '采购合同新增',
          },
          // {
          //   path: '/BaseManager/index',
          //   meta: { requiresAuth: true },
          //   component: require('../pages/BaseManager/index'),
          //   desc: '基础管理',
          // },
          {
            path: '/BaseManager/currency',
            meta: { requiresAuth: true },
            component: require('../pages/BaseManager/currency'),
            desc: '币种管理',
          },
          {
            path: '/BaseManager/area',
            meta: { requiresAuth: true },
            component: require('../pages/BaseManager/area'),
            desc: '产地管理',
          },
           {
            path: '/BaseManager/product_type',
            meta: { requiresAuth: true },
            component: require('../pages/BaseManager/product_type'),
            name: 'product_type',
            desc: '品种牌号管理',
          },
           {
            path: '/BaseManager/warehouse',
            meta: { requiresAuth: true },
            component: require('../pages/BaseManager/warehouse'),
            desc: '库区库位管理',
          },
           {
            path: '/BaseManager/customer',
            meta: { requiresAuth: true },
            component: require('../pages/BaseManager/customer'),
            desc: '客户管理',
          },
           {
            path: '/BaseManager/supplier',
            meta: { requiresAuth: true },
            component: require('../pages/BaseManager/supplier'),
            desc: '供应商管理',
          },
          {
            path: '/BaseManager/accrual',
            meta: { requiresAuth: true },
            component: require('../pages/BaseManager/contract'),
            desc: '销售合同基础利率',
          },
          {
            path: '/BaseManager/calendar',
            meta: { requiresAuth: true },
            component: require('../pages/BaseManager/calendar'),
            desc: '工作日历',
          },
          {
            path: '/BaseManager/work',
            meta: { requiresAuth: true },
            component: require('../pages/BaseManager/work'),
            desc: '班制班组维护',
          },
          {
            path: '/BaseManager/logistics',
            meta: { requiresAuth: true },
            component: require('../pages/BaseManager/logistics'),
            desc: '物流基础数据',
          },
          {
            path: '/BaseManager/base_data',
            meta: { requiresAuth: true },
            component: require('../pages/BaseManager/base_data'),
            desc: '生产基础数据',
          },



          // 合起来
          {
            path: '/addmeau',
            meta: { requiresAuth: true },
            name: 'addmeau',
            component: require('../pages/addmeau.vue'),
            desc: '在线库存查询',
          },
          {
            path: '/delivery',
            meta: { requiresAuth: true },
            name: 'delivery',
            component: require('../pages/delivery.vue'),
            desc: '提货申请',
          },
          {
            path: '/addmeauTwo',
            meta: { requiresAuth: true },
            name: 'addmeauTwo',
            component: require('../pages/addmeauTwo.vue'),
            desc: '已出库查询',
          },
          {
            path: '/addpost',
            meta: { requiresAuth: true },
            name: 'addpost',
            component: require('../pages/addpost.vue'),
            desc: '在线订单',
          },
          {
            path: '/lading',
            meta: { requiresAuth: true },
            name: 'lading',
            component: require('../pages/lading.vue'),
            desc: '销售提单查看',
          },
          {
            path: '/warranty',
            meta: { requiresAuth: true },
            name: 'warranty',
            component: require('../pages/warranty.vue'),
            desc: '质保书查询',
          },
          {
            path: '/ladingsee',
            meta: { requiresAuth: true },
            name: 'ladingsee',
            component: require('../pages/ladingsee.vue'),
            desc: '提货申请查看',
          },
          {
            path: '/addDingDan',
            meta: { requiresAuth: true },
            name: 'addDingDan',
            component: require('../pages/addDingDan.vue'),
            desc: '加工订单申请',
          },
          {
            path: '/qualitative',
            meta: { requiresAuth: true },
            name: 'qualitative',
            component: require('../pages/qualitative.vue'),
            desc: '质量数据查询与分析',
          },
          {
            path: '/Original',
            meta: { requiresAuth: true },
            name: 'Original',
            component: require('../pages/Original.vue'),
            desc: '提货计划',
          },
          {
            path: '/firstpage',
            meta: { requiresAuth: true },
            name: 'Original',
            component: require('../pages/firstpage.vue'),
            desc: '首页',
          },
           {
            path: '/404',
            name: '404',
            component: Error,
            desc: '404未找到'
          },
      ],
     
      beforeEnter (to, from, next) {
          console.log(to.path)
          //to即将进入的目标路由对象，from当前导航正要离开的路由， next : 下一步执行的函数钩子
          if(to.path === '/login') {  // 如果即将进入登录路由，则直接放行
            next()
          }else{   //进入的不是登录路由
              //下一跳路由需要登录验证，并且还未登录，则路由定向到 登录路由
             // console.log(222)
              if(to.meta.requireAuth || !sessionStorage.getItem('islogin')) {
                  console.log(222)
                  // console.log(next)
                  next({ path: '/login' })
                  // console.log(next.path)
              } else { //如果不需要登录验证，或者已经登录成功，则直接放行
                next()
              }

          }
      }
    },
   {
      path: '*',
      redirect: { name: '404' }
   }

      //
    // {
    //   path: '/Register',
    //   name: 'Register',
    //   component: Register,
    // },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js